module.exports = __webpack_public_path__ + "img/00022.f97ee6b8.webp";